import { mapState, mapActions, mapMutations } from 'vuex';
import actions from './actions';
import state from './state';
import mutations from './mutations';

export const serviceComputed = {
	...mapState('userGroupMapStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('userGroupMapStore', Object.keys(actions)),
	...mapMutations('userGroupMapStore', Object.keys(mutations))
};
